<template>
    <el-dialog title="自建库配煤" :visible="visible" :show="show" width="75%" @close="close" :close-on-click-modal="false" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" >
            <el-form-item label="到场地" class="input" prop="arrtiveStation">
                <el-select v-model="ruleForm.arrtiveStation"  placeholder="到场地"  style="width:48%" @change="changeStation">
                    <el-option v-for="item in zdList" :value="item.orgName" :label="item.orgName" :key="item.orgId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="目标热值" class="input" prop="targetHots">
                <el-input v-model.number="ruleForm.targetHots" autocomplete="off" placeholder="目标热值"></el-input>
            </el-form-item>
            <el-form-item label="目标硫分" class="input" prop="targetLiufen">
                <el-input v-model="ruleForm.targetLiufen" autocomplete="off" placeholder="目标硫分"></el-input>
            </el-form-item>
            <el-form-item label="目标吨数" class="input" prop="totalCount">
                <el-input v-model.number="ruleForm.totalCount" autocomplete="off" placeholder="目标吨数"></el-input>
            </el-form-item>
            <el-form-item label="最大煤泥占比" class="input" prop="maxMnWeight">
                <el-input v-model.number="ruleForm.maxMnWeight" autocomplete="off" placeholder="最大煤泥占比"></el-input>
            </el-form-item>
            <el-collapse v-model="activeNames">
                <el-collapse-item title="自建库煤源" name="2" :disabled="!disabled">
                    <el-table :data="ownerDataList" border style="width: 100%" height="400px" @selection-change="selectOwnerListMethod">
                        <el-table-column
                                type="selection"
                                header-align="center"
                                align="center"
                                width="50">
                        </el-table-column>
                        <el-table-column label="索引"  type="index" width="50" fixed></el-table-column>
                        <el-table-column  align="center" prop="cocalName"  label="煤炭名称" fixed width="200"></el-table-column>
                        <el-table-column  align="center" label="调用（吨）" fixed width="200">
                            <template slot-scope="scope">
                                <el-input-number v-model="scope.row.useWeight" size="min" :controls="false"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column  align="center" prop="personName1"  label="联系人" fixed></el-table-column>
                        <el-table-column  align="center" prop="cocalType"  label="煤种类型" fixed></el-table-column>
                        <el-table-column  align="center" prop="hots"  label="热值" sortable="custom"></el-table-column>
                        <el-table-column  align="center" prop="liufen"  label="硫分"></el-table-column>
                        <el-table-column  align="center" prop="unitPrice"  label="含税单价" sortable="custom" width="130"></el-table-column>
                        <el-table-column  align="center" prop="stock"  label="库存"></el-table-column>
                        <el-table-column  align="center" prop="arriveStation"  label="到场地"></el-table-column>
                        <el-table-column  align="center" prop="hsPrice"  label="含税运费" sortable="custom" width="100"></el-table-column>
                        <el-table-column  align="center" prop="stationPrice"  label="场地费" sortable="custom" width="90"></el-table-column>
                    </el-table>
                </el-collapse-item>
                <el-collapse-item title="系统煤源" name="1" :disabled="!disabled">
                    <el-table :data="dataList" border style="width: 100%" height="400px" @selection-change="selectionChangeHandler">
                        <el-table-column
                                type="selection"
                                header-align="center"
                                align="center"
                                width="50">
                        </el-table-column>
                        <el-table-column label="索引"  type="index" width="50" fixed />
                        <el-table-column  align="center" prop="cocalName"  label="煤炭名称" fixed width="200"></el-table-column>
                        <el-table-column  align="center" prop="personName1"  label="联系人" fixed></el-table-column>
                        <el-table-column  align="center" prop="mobile1"  label="联系电话" fixed></el-table-column>
                        <el-table-column  align="center" prop="cocalType"  label="煤种类型" fixed></el-table-column>
                        <el-table-column  align="center" prop="hots"  label="热值" sortable="custom"></el-table-column>
                        <el-table-column  align="center" prop="liufen"  label="硫分"></el-table-column>
                        <el-table-column  align="center" prop="unitPrice"  label="含税单价" sortable="custom" width="130"></el-table-column>
                        <el-table-column  align="center" prop="isBroken"  label="是否破碎"></el-table-column>
                        <el-table-column  align="center" prop="stock"  label="库存"></el-table-column>
                        <el-table-column  align="center" prop="arriveStation"  label="到场地"></el-table-column>
                        <el-table-column  align="center" prop="hsPrice"  label="含税运费" sortable="custom" width="100"></el-table-column>
                        <el-table-column  align="center" prop="stationPrice"  label="场地费" sortable="custom" width="90"></el-table-column>
                    </el-table>
                </el-collapse-item>
            </el-collapse>

            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" @click="commit()">提交</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'cocalOwnerMatchAdd',
        props:{
            show: {
                type: Boolean,
                default: false
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    //                    this.getSystemCocalList();
                    //                    this.getOwnerCocalList();
                    this.getZdList();
                }
            },
        },
        data(){
            var validateTotalCount = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入数字'));
                }
                setTimeout(() => {
                    if (!Number.isNaN(value) && value%100==0) {
                        callback();
                    } else {
                        callback(new Error('请输入100的倍数'));
                    }
                }, 100);
            };
            var validateNumber = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入数字'));
                }
                setTimeout(() => {
                    if (!Number.isNaN(value) && /^-?\d+(\.\d+)?$/.test(value)) {
                        callback();
                    } else {
                        callback(new Error('请输入有效的数字或小数'));
                    }
                }, 100);
            };
            return{
                disabled:false,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    arrtiveStation:'',
                    targetHots:'',
                    targetLiufen:'',
                    totalCount:'',
                },
                rules:{
                    arrtiveStation:[{ required: true, message: '请输入到场地', trigger: 'blur' }],
                    targetHots:[{ required: true, message: '请输入目标热值', trigger: 'blur' },
                        {type:'number',message:'请输入数字',trigger:'blur'}
                    ],
                    targetLiufen:[{ required: true, message: '请输入硫分', trigger: 'blur' },
                        {validator:validateNumber,trigger:'blur'}
                    ],
                    totalCount:[{ required: true, message: '请输入目标吨数', trigger: 'blur' },
                        {validator:validateTotalCount,trigger:'blur'}
                    ],

                },
                selectSystemList:[],
                dataList:[],
                ownerDataList:[],
                selectOwnerList:[],
                activeNames:[],
                zdList:[],
            }
        },
        methods:{
            close(){
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
                this.activeNames = [];
            },
            parseWeight(useWeight,totalCount){
                let weight = (useWeight/totalCount) * 100;
                return weight | 0;
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        let totalCount = this.ruleForm.totalCount;
                        if (this.selectOwnerList.length<=0){
                            this.$message.warning("请选择自建库煤源！");
                            this.activeNames = ['2'];
                            return;
                        }
                        let weight = 0;
                        let selectOwnCocals = '';
                        let selectOwnWeightCocals = '';
                        let selectSystemCocalIds = '';
                        this.selectOwnerList.map(item=>{
                            if (item.useWeight==undefined){
                                selectOwnCocals += item.id+",";
                            }else{
                                if (item.useWeight>totalCount){
                                    this.$message.warning("您输入的调运量超过总调运量，请调整");
                                    return;
                                }
                                if (item.useWeight>item.stock){
                                    this.$message.warning("您输入的调运量超过自建库库存，请调整");
                                    return;
                                }
                                let cocalWeight = this.parseWeight(item.useWeight,totalCount);
                                if (cocalWeight<5){
                                    this.$message.warning("您输入自建库调运量低于最低要求，请调整");
                                }
                                weight+= cocalWeight;
                                let str = item.id+":"+cocalWeight+",";
                                selectOwnWeightCocals+= str;
                            }

                        })
                        selectOwnCocals = selectOwnCocals.substring(0,selectOwnCocals.length-1);
                        selectOwnWeightCocals = selectOwnWeightCocals.substring(0,selectOwnWeightCocals.length-1);
                        if (weight>90){
                            this.$message.warning("自建库煤源占比已超过最大限度，请调整！");
                            this.activeNames = ['2'];
                            return;
                        }
                        console.log(selectOwnWeightCocals);
                        if (selectOwnWeightCocals.split(",").length>3){
                            this.$message.warning("自建库输入条数过多请调整！");
                            this.activeNames = ['2'];
                            return;
                        }

                        let systemListStr = '';
                        this.selectSystemList.map(item=>{
                            let str = item.id+",";
                            systemListStr+= str;
                        })
                        this.ruleForm.selectSystemCocalIds = systemListStr;
                        this.ruleForm.selectOwnCocals = selectOwnCocals;
                        this.ruleForm.selectOwnWeightCocals = selectOwnWeightCocals;
                        let loading = this.$loading({
                            lock:true,
                            text:'计算中，请稍候.....',
                            background:'rgba(0,0,0,0.5)'
                        });
                        this.ruleForm.matchType = '自建库配煤';
                        if (this.ruleForm.maxMnWeight=='' || this.ruleForm.maxMnWeight==null){
                            this.ruleForm.maxMnWeight = 100;
                        }
                        this.$http({
                            url:  this.url+`cocalMatchResult/`+"saveOwner",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            loading.close();
                            if (data && data.code === 0) {
                                this.$message({
                                    message: data.msg,
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            // 多选
            selectionChangeHandler(val) {
                this.selectSystemList = val;
            },

            selectOwnerListMethod(val){
                this.selectOwnerList = val;
            },
            //获取系统煤源
            getSystemCocalList(stationName){
                let result = {'arriveStation':stationName};
                this.$http({
                    url: "cocalTemplate/list/",
                    method: "get",
                    params:result
                }).then(({data}) => {
                    this.dataList = data.data;
                });
            },
            //获取自建库煤源
            getOwnerCocalList(stationName){
                let result = {'arriveStation':stationName};
                this.$http({
                    url: "cocalTemplateOwner/list/",
                    method: "get",
                    params:result
                }).then(({data}) => {
                    this.ownerDataList = data.data;
                });
            },
            changeStation(){
                if (this.ruleForm.arrtiveStation==''){
                    this.disabled = false;
                    this.ruleForm.selectSystemCocalIds = '';
                    this.ruleForm.selectOwnCocals = '';
                    this.ruleForm.selectOwnWeightCocals = '';
                }else{
                    this.disabled = true;
                    this.getOwnerCocalList(this.ruleForm.arrtiveStation);
                    this.getSystemCocalList(this.ruleForm.arrtiveStation);
                }
            },
            getZdList(){
                let userId = this.$storage.get("userId");
                this.$http({
                    url:'/sysUserOrg/getZdListByUserId/'+userId,
                    method: "get",
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.zdList = data.zdList;
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
    .module-dialog .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }
    .module-dialog .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }
    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
    }
    .detail-form-content .el-select {
        width: 100%;
    }
    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }
    .el-collapse-item__header {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
    }
</style>